import { render, staticRenderFns } from "./CodeTypeDialog.vue?vue&type=template&id=191931bc&scoped=true"
import script from "./CodeTypeDialog.vue?vue&type=script&lang=js"
export * from "./CodeTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191931bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('191931bc')) {
      api.createRecord('191931bc', component.options)
    } else {
      api.reload('191931bc', component.options)
    }
    module.hot.accept("./CodeTypeDialog.vue?vue&type=template&id=191931bc&scoped=true", function () {
      api.rerender('191931bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGenerator/index/CodeTypeDialog.vue"
export default component.exports